import { render, staticRenderFns } from "./animalVerticalDetail.vue?vue&type=template&id=5fbabeb3&scoped=true"
import script from "./animalVerticalDetail.vue?vue&type=script&lang=js"
export * from "./animalVerticalDetail.vue?vue&type=script&lang=js"
import style0 from "./animalVerticalDetail.vue?vue&type=style&index=0&id=5fbabeb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbabeb3",
  null
  
)

export default component.exports